import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { toLabelSelectItems } from '../../../Label'

import { REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS } from './RequestProfileWidgetLabels.constants'

export function getInitialValues(labels) {
  return {
    [REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS]: toLabelSelectItems(
      labels || EMPTY_LIST
    ),
  }
}

export function getWidgetLabels(labels = EMPTY_LIST) {
  return labels.map(label => ({
    backgroundColor: label.color,
    id: label.id,
    text: label.name,
  }))
}

export function getPayload(values) {
  return {
    [REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS]: {
      label_ids: getItemsIds(
        values[REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS],
        'value'
      ),
    },
  }
}
